module.exports = __webpack_public_path__ + "public/img/logo_tokopedia.558e30fd.svg";